import { render, staticRenderFns } from "./EditRepairSetting.vue?vue&type=template&id=50e37546"
import script from "./EditRepairSetting.vue?vue&type=script&lang=js"
export * from "./EditRepairSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports